import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import PaginationManager from "../../view/PaginationManager";
import { VulscanConfigManagement } from "./VulscanConfigManagement";
import VulscanTableHeader from "./VulscanTableHeader";
import VulscanTable from "./VulscanTable";
import * as vulscanService from "./vulscanService";
import VulscanScheduleCardModal from "./vulscan-schedule/VulscanScheduleCardModal";

function VulscanTableSection() {

    const history = useHistory();
    const [showModal, setShowModal] = useState(false);
    const [modalProps, setModalProps] = useState({});

    const handleShowModal = (props) => {
        setModalProps(props);
        setShowModal(true);
    }
    const onCloseModal = () => {
        history.go(0);
        setTableConfig({ ...tableConfig, lastUpdated: Date.now() });
        setShowModal(false);
    }
    const initTableConfig = {
        selected: [],
        showModal: handleShowModal
    }

    // results: [],
    // allResults: [],

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return ( 
        <>
            {showModal && <VulscanScheduleCardModal handleClose={onCloseModal} {...modalProps} />}       
            <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
                <VulscanConfigManagement />
                <div className="container-fluid" key={history.location}>
                    <div className="row">
                        <div className="col-12">
                            <div className="card oct_table-card-v2 network-scan-table-card-v2">
                                <VulscanTableHeader />
                                <div className="card-body">
                                    <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                        <div className="row">
                                            <div className="col-sm-12 p-0">
                                                <VulscanTable />
                                                <PaginationManager
                                                    getPage={vulscanService.listPageable}
                                                    blocked={tableConfig.filtersLoading} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </TableContext.Provider>
        </>
    )
}

export default VulscanTableSection;
